import {SvgIcon} from '@material-ui/core';
import React from 'react';

export function PlayIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <polygon points="6 4 6 29.767 28.944 16 6 2.233 6 4" />
            </svg>
        </SvgIcon>
    );
}

export function ClearPointsIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path d="M6.1 6.1l19.8 19.8-1.415 1.414-3.465-3.466V30H19l-.001-8.173-8.72-8.72L7.357 16 13 21.586V30h-2.02v-7.586L4.5 16l4.358-4.314-4.172-4.171L6.101 6.1zM21 2l.02 7.586L27.5 16l-4.358 4.314-1.422-1.422L24.643 16 19 10.414V2h2zm-8 0v8.172l-2.021-2.021V2H13z" />
            </svg>
        </SvgIcon>
    );
}

export function PauseIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <rect
                    x="19"
                    y="8"
                    width="6"
                    height="16"
                />
                <rect
                    x="7"
                    y="8"
                    width="6"
                    height="16"
                />
            </svg>
        </SvgIcon>
    );
}

export function NextIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <polygon points="28 30 28 2 26 2 26 14.834 5 2.233 5 4 5 29.767 26 17.166 26 30 28 30" />
            </svg>
        </SvgIcon>
    );
}

export function PreviousIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <polygon points="4 2 4 30 6 30 6 17.166 27 29.767 27 2.233 25.485 3.143 6 14.834 6 2 4 2" />
            </svg>
        </SvgIcon>
    );
}

export function JumpForwardIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path d="M25.565,17h0A10.009,10.009,0,1,1,15.129,7.022L12.858,9.293l1.415,1.414L18.98,6,14.273,1.293,12.858,2.707,15.171,5.02A11.993,11.993,0,1,0,27.565,17Z" />
            </svg>
        </SvgIcon>
    );
}

export function JumpBackwardIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path d="M15.96,5.02l2.313-2.313L16.858,1.293,12.151,6l4.707,4.707,1.415-1.414h0L16,7.022A9.991,9.991,0,1,1,5.565,17h-2A12,12,0,1,0,15.96,5.02Z" />
            </svg>
        </SvgIcon>
    );
}

export function FullScreenIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path d="M5,30h7V28H5a1,1,0,0,1-1-1V20H2v7A3,3,0,0,0,5,30Z" />
                <path d="M4,5A1,1,0,0,1,5,4h7V2H5A3,3,0,0,0,2,5v7H4Z" />
                <path d="M27,2H20V4h7a1,1,0,0,1,1,1v7h2V5A3,3,0,0,0,27,2Z" /><path d="M28,27a1,1,0,0,1-1,1H20v2h7a3,3,0,0,0,3-3V20H28Z" />
            </svg>
        </SvgIcon>
    );
}

export function SetInpointIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <polygon points="19 2 17 2 17 9.586 10.586 16 17 22.414 17 30 19 30 19 21.586 13.414 16 19 10.414 19 2" />
            </svg>
        </SvgIcon>
    );
}

export function SetOutpointIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <polygon points="13 30 15 30 15 22.414 21.414 16 15 9.586 15 2 13 2 13 10.414 18.586 16 13 21.586 13 30" />
            </svg>
        </SvgIcon>
    );
}

export function CreateNoteIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path d="M25,4V19l-9,9L7,19V4Z" />
            </svg>
        </SvgIcon>
    );
}

export function CreateAdBreakIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path
                    d="M29 16L16 29 3 16 16 3l13 13z"
                    fill="#fff"
                />
            </svg>
        </SvgIcon>
    );
}

export function CreateMarkupIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path
                    d="M6 25h4.378v-9.566L14.368 25h3.135l4.119-9.566V25H26V7h-4.456l-5.259 11.623L11.337 7H6v18z"
                    fill="#fff"
                />
            </svg>
        </SvgIcon>
    );
}

export function GoToInIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <polygon points="15 9.586 8.586 16 15 22.414 15 30 17 30 17 21.586 11.414 16 17 10.414 17 2 15 2 15 9.586" />
                <polygon points="21 21 21 11 16 16 21 21" />
            </svg>
        </SvgIcon>
    );
}

export function GoToOutIcon() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <polygon points="11 21 16 16 11 11 11 21" />
                <polygon points="15 2 15 10.414 20.586 16 15 21.586 15 30 17 30 17 22.414 23.414 16 17 9.586 17 2 15 2" />
            </svg>
        </SvgIcon>
    );
}

export function MoveMarker() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path
                    d="M16 3c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5C23.5 6.36 20.14 3 16 3z"
                    fill="#fff"
                />
                <path
                    d="M10.5 12c0-3.036 2.464-5.5 5.5-5.5s5.5 2.464 5.5 5.5a5.504 5.504 0 01-4.5 5.41V29h-2V17.41A5.504 5.504 0 0110.5 12z"
                    fill="#fff"
                />
            </svg>
        </SvgIcon>
    );
}

export function GoToMarker() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path
                    d="M32 5v13.75L23 27l-9-8.25V5h18zM5 7l6 6-6 6v-4H0v-4h5V7z"
                    fill="#FFF"
                />
            </svg>
        </SvgIcon>
    );
}

export function GoToPrevious() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <defs>
                    <filter id="a">
                        <feColorMatrix
                            in="SourceGraphic"
                            values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
                        />
                    </filter>
                </defs>
                <g
                    filter="url(#a)"
                    fill="none"
                    fillRule="evenodd"
                >
                    <path
                        fill="#FFF"
                        d="M8 19v6.25L4 29l-4-3.75V19z"
                    />
                    <path
                        fillOpacity=".6"
                        fill="#FFF"
                        d="M32 19v6.25L28 29l-4-3.75V19z"
                    />
                    <path
                        d="M26.895 9.762C21.133 2.848 14.18 3.398 9.865 7.713"
                        stroke="#231F20"
                        strokeWidth="1.4"
                    />
                    <path
                        fill="#231F20"
                        fillRule="nonzero"
                        d="M13.343 9.617l-7.35 1.97 1.969-7.353z"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}

export function GoToNext() {
    return (
        <SvgIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <defs>
                    <filter id="a">
                        <feColorMatrix
                            in="SourceGraphic"
                            values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
                        />
                    </filter>
                </defs>
                <g
                    filter="url(#a)"
                    fill="none"
                    fillRule="evenodd"
                >
                    <path
                        fill="#FFF"
                        d="M24 19v6.25L28 29l4-3.75V19z"
                    />
                    <path
                        fillOpacity=".6"
                        fill="#FFF"
                        d="M0 19v6.25L4 29l4-3.75V19z"
                    />
                    <path
                        d="M22.135 7.713C17.82 3.398 10.867 2.848 5.105 9.762"
                        stroke="#231F20"
                        strokeWidth="1.4"
                    />
                    <path
                        fill="#231F20"
                        fillRule="nonzero"
                        d="M18.657 9.617l7.35 1.97-1.969-7.353z"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}

export function GoToStart() {
    return (
        <SvgIcon>
            <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 5v13.75L13 27l9-8.25V5H4z"
                    fill="#fff"
                    fillOpacity=".4"
                />
                <path
                    d="M4 18.75V5h9v22l-9-8.25z"
                    fill="#fff"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 13l6 6v-4h5v-4h-5V7l-6 6z"
                    fill="#fff"
                />
            </svg>
        </SvgIcon>
    );
}

export function GoToEnd() {
    return (
        <SvgIcon>
            <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M28 5V18.75L19 27L10 18.75V5H28Z"
                    fill="white"
                    fillOpacity="0.4"
                />
                <path
                    d="M28 18.75V5H19V27L28 18.75Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 13L9 19V15H4V11H9V7L15 13Z"
                    fill="white"
                />
            </svg>
        </SvgIcon>
    );
}
